/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RosterFieldType } from './RosterFieldType';
import {
    RosterFieldTypeFromJSON,
    RosterFieldTypeFromJSONTyped,
    RosterFieldTypeToJSON,
    RosterFieldTypeToJSONTyped,
} from './RosterFieldType';

/**
 * 
 * @export
 * @interface RosterFieldSpec
 */
export interface RosterFieldSpec {
    /**
     * Lookup key into a member's fieldValues.
     * @type {string}
     * @memberof RosterFieldSpec
     */
    key: string;
    /**
     * Human-readable label. Required even for FLAG, which renders no text — it is what the accessible name is built from, and a badge with no accessible name is invisible to a screen reader.
     * @type {string}
     * @memberof RosterFieldSpec
     */
    label: string;
    /**
     * 
     * @type {RosterFieldType}
     * @memberof RosterFieldSpec
     */
    type: RosterFieldType;
    /**
     * Which system supplies the value. "member" for something stored on the roster row; otherwise the name of the system that computes it (e.g. "predictions"). Deliberately an open string — a gamification system may supply a number, so closing the set would mean editing the model every time one wanted to.
     * @type {string}
     * @memberof RosterFieldSpec
     */
    source?: string;
}



/**
 * Check if a given object implements the RosterFieldSpec interface.
 */
export function instanceOfRosterFieldSpec(value: object): value is RosterFieldSpec {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function RosterFieldSpecFromJSON(json: any): RosterFieldSpec {
    return RosterFieldSpecFromJSONTyped(json, false);
}

export function RosterFieldSpecFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosterFieldSpec {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'type': RosterFieldTypeFromJSON(json['type']),
        'source': json['source'] == null ? undefined : json['source'],
    };
}

export function RosterFieldSpecToJSON(json: any): RosterFieldSpec {
    return RosterFieldSpecToJSONTyped(json, false);
}

export function RosterFieldSpecToJSONTyped(value?: RosterFieldSpec | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'type': RosterFieldTypeToJSON(value['type']),
        'source': value['source'],
    };
}

